import React from 'react';
import Checkbox, {CheckboxProps} from '@mui/material/Checkbox';
import {Typography} from '@mui/material';

export interface AppCheckboxProps extends CheckboxProps {
    label: string;
    labelPosition?: 'top' | 'bottom' | 'start' | 'end';
}

export const AppCheckbox = React.forwardRef<HTMLButtonElement, AppCheckboxProps>((props, ref) => {
    const {label, labelPosition = 'start', ...rest} = props;
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: labelPosition === 'top' || labelPosition === 'bottom' ? 'column' : 'row',
                alignItems: 'center',
            }}
        >
            {(labelPosition === 'top' || labelPosition === 'start') && (
                <Typography
                    variant="caption"
                    style={{
                        marginBottom: labelPosition === 'top' ? 1 : 0,
                        marginRight: labelPosition === 'start' ? 1 : 0,
                    }}
                >
                    {label}
                </Typography>
            )}
            <Checkbox {...rest} ref={ref} />
            {(labelPosition === 'bottom' || labelPosition === 'end') && (
                <Typography
                    variant="caption"
                    style={{
                        marginTop: labelPosition === 'bottom' ? 4 : 0,
                        marginLeft: labelPosition === 'end' ? 8 : 0,
                    }}
                >
                    {label}
                </Typography>
            )}
        </div>
    );
});

export default AppCheckbox;
